// import BrowserModal from '@/components/views/BrowserModal'
import Navigation from '@/components/views/Navigation'
import NavFooter from '@/components/views/NavFooter'

export default {
    components: {
        // BrowserModal,
        Navigation,
        NavFooter
    }
}
